import BaseLoadingButton from '@components/common/atoms/BaseLoadingButton';
import BaseTextField from '@components/common/form/components/BaseTextField';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import RoomTwoToneIcon from '@mui/icons-material/RoomTwoTone';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UserAddressEditViewStore from '../stores/UserAddressEditViewStore';
import UserAddressOptionList from './UserAddressOptionList';
import UserAddressInfo from './UserAddressInfo';

interface UserAddressProps {
    userAddressEditViewStore: UserAddressEditViewStore;
}

const UserAddress: React.FC<UserAddressProps> = observer(({ userAddressEditViewStore }) => {
    const { form, isLoading, userAddressOption } = userAddressEditViewStore;
    return (
        <>
            <UserAddressOptionList userAddressEditViewStore={userAddressEditViewStore} />
            <form>
                <Paper elevation={0}>
                    <Grid
                        container
                        direction={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}>
                        <Box
                            mt={4}
                            mb={2}
                            width={"100%"}
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}>
                            <BaseTextField
                                field={form.$("address")}
                                fullWidth
                                icon={<RoomTwoToneIcon />} />

                            <BaseTextField
                                field={form.$("locationDescription")}
                                fullWidth
                                icon={<DescriptionTwoToneIcon />}
                                sx={{ mt: 2.5 }} />
                        </Box>

                        <UserAddressInfo userAddressOption={userAddressOption} />

                        <BaseLoadingButton
                            variant="contained"
                            color='secondary'
                            isLoading={isLoading}
                            disabled={isLoading || !form.isValid}
                            onClick={form.onSubmit}
                            fullWidth
                            sx={{
                                mt: 2
                            }}
                            >
                            <Typography>Spremi</Typography>
                        </BaseLoadingButton>
                    </Grid>
                </Paper>
            </form>
        </>

    )
})

export default UserAddress;